module.exports = __webpack_public_path__ + "assets/img/WechatIMG63.d66b2bd5.png";